// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import axios from "axios";

// // --- BASE CONFIG ---
// const API_BASE = "http://localhost:3006/api/management/engagement/metric";
// const HEADERS = {
//   accept: "application/json",
//   "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
// };

// // --- THUNKS ---

// export const fetchLastThreeIndustries = createAsyncThunk(
//   "metrics/fetchLastThreeIndustries",
//   async (buyerId, { rejectWithValue }) => {
//     try {
//       const res = await axios.get(`${API_BASE}/monthly/last-three/industry`, {
//         headers: HEADERS,
//         params: { buyerId },
//       });
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

// export const fetchCurrentIndustries = createAsyncThunk(
//   "metrics/fetchCurrentIndustries",
//   async (buyerId, { rejectWithValue }) => {
//     try {
//       const res = await axios.get(`${API_BASE}/monthly/current/industry`, {
//         headers: HEADERS,
//         params: { buyerId },
//       });
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

// export const fetchYearlyIndustries = createAsyncThunk(
//   "metrics/fetchYearlyIndustries",
//   async (buyerId, { rejectWithValue }) => {
//     try {
//       const res = await axios.get(`${API_BASE}/yearly/industry`, {
//         headers: HEADERS,
//         params: { buyerId },
//       });
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

// // --- SLICE ---
// const metricsSlice = createSlice({
//   name: "metrics",
//   initialState: {
//     lastThree: { data: null, loading: false, error: null },
//     current: { data: null, loading: false, error: null },
//     yearly: { data: null, loading: false, error: null },
//   },
//   reducers: {},
//   extraReducers: (builder) => {
//     // ---- last-three ----
//     builder
//       .addCase(fetchLastThreeIndustries.pending, (state) => {
//         state.lastThree.loading = true;
//         state.lastThree.error = null;
//       })
//       .addCase(fetchLastThreeIndustries.fulfilled, (state, action) => {
//         state.lastThree.loading = false;
//         state.lastThree.data = action.payload;
//       })
//       .addCase(fetchLastThreeIndustries.rejected, (state, action) => {
//         state.lastThree.loading = false;
//         state.lastThree.error = action.payload;
//       });

//     // ---- current ----
//     builder
//       .addCase(fetchCurrentIndustries.pending, (state) => {
//         state.current.loading = true;
//         state.current.error = null;
//       })
//       .addCase(fetchCurrentIndustries.fulfilled, (state, action) => {
//         state.current.loading = false;
//         state.current.data = action.payload;
//       })
//       .addCase(fetchCurrentIndustries.rejected, (state, action) => {
//         state.current.loading = false;
//         state.current.error = action.payload;
//       });

//     // ---- yearly ----
//     builder
//       .addCase(fetchYearlyIndustries.pending, (state) => {
//         state.yearly.loading = true;
//         state.yearly.error = null;
//       })
//       .addCase(fetchYearlyIndustries.fulfilled, (state, action) => {
//         state.yearly.loading = false;
//         state.yearly.data = action.payload;
//       })
//       .addCase(fetchYearlyIndustries.rejected, (state, action) => {
//         state.yearly.loading = false;
//         state.yearly.error = action.payload;
//       });
//   },
// });

// export default metricsSlice.reducer;


import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// --- BASE CONFIG ---
const API_BASE = "http://localhost:3006/api/management/engagement/metric";
const HEADERS = {
  accept: "application/json",
  "x-api-key": "G8js92h02h3j0s0sk2jhsj392slk20s",
};

// --- EXISTING THUNKS (Industries) ---
export const fetchLastThreeIndustries = createAsyncThunk(
  "metrics/fetchLastThreeIndustries",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/monthly/last-three/industry`, {
        headers: HEADERS,
        params: { buyerId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentIndustries = createAsyncThunk(
  "metrics/fetchCurrentIndustries",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/monthly/current/industry`, {
        headers: HEADERS,
        params: { buyerId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchYearlyIndustries = createAsyncThunk(
  "metrics/fetchYearlyIndustries",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/yearly/industry`, {
        headers: HEADERS,
        params: { buyerId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// --- NEW THUNKS (Metrics) ---
export const fetchLastThreeMetrics = createAsyncThunk(
  "metrics/fetchLastThreeMetrics",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/monthly/last-three`, {
        headers: HEADERS,
        params: { buyerId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentMetrics = createAsyncThunk(
  "metrics/fetchCurrentMetrics",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/monthly/current`, {
        headers: HEADERS,
        params: { buyerId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchYearlyMetrics = createAsyncThunk(
  "metrics/fetchYearlyMetrics",
  async (buyerId, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${API_BASE}/yearly`, {
        headers: HEADERS,
        params: { buyerId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

// --- SLICE ---
const metricsSlice = createSlice({
  name: "metrics",
  initialState: {
    // Industries
    lastThree: { data: null, loading: false, error: null },
    current: { data: null, loading: false, error: null },
    yearly: { data: null, loading: false, error: null },

    // Metrics
    lastThreeMetrics: { summary: null, metrics: null, highestSpend: null, loading: false, error: null },
    currentMetrics: { summary: null, metrics: null, highestSpend: null, loading: false, error: null },
    yearlyMetrics: { summary: null, metrics: null, highestSpend: null, loading: false, error: null },
  },
  reducers: {},
  extraReducers: (builder) => {
    // ===== Industries =====
    builder
      // --- last-three industries ---
      .addCase(fetchLastThreeIndustries.pending, (state) => {
        state.lastThree.loading = true;
        state.lastThree.error = null;
      })
      .addCase(fetchLastThreeIndustries.fulfilled, (state, action) => {
        state.lastThree.loading = false;
        state.lastThree.data = action.payload;
      })
      .addCase(fetchLastThreeIndustries.rejected, (state, action) => {
        state.lastThree.loading = false;
        state.lastThree.error = action.payload;
      })
      // --- current industries ---
      .addCase(fetchCurrentIndustries.pending, (state) => {
        state.current.loading = true;
        state.current.error = null;
      })
      .addCase(fetchCurrentIndustries.fulfilled, (state, action) => {
        state.current.loading = false;
        state.current.data = action.payload;
      })
      .addCase(fetchCurrentIndustries.rejected, (state, action) => {
        state.current.loading = false;
        state.current.error = action.payload;
      })
      // --- yearly industries ---
      .addCase(fetchYearlyIndustries.pending, (state) => {
        state.yearly.loading = true;
        state.yearly.error = null;
      })
      .addCase(fetchYearlyIndustries.fulfilled, (state, action) => {
        state.yearly.loading = false;
        state.yearly.data = action.payload;
      })
      .addCase(fetchYearlyIndustries.rejected, (state, action) => {
        state.yearly.loading = false;
        state.yearly.error = action.payload;
      });

    // ===== Metrics =====
    builder
      // --- last-three metrics ---
      .addCase(fetchLastThreeMetrics.pending, (state) => {
        state.lastThreeMetrics.loading = true;
        state.lastThreeMetrics.error = null;
      })
      .addCase(fetchLastThreeMetrics.fulfilled, (state, action) => {
        state.lastThreeMetrics.loading = false;
        state.lastThreeMetrics.summary = action.payload.lastThreeMonthSummary;
        state.lastThreeMetrics.metrics = action.payload.lastThreeMonthsMetric;
        state.lastThreeMetrics.highestSpend = action.payload.highestSpendSuppliers;
      })
      .addCase(fetchLastThreeMetrics.rejected, (state, action) => {
        state.lastThreeMetrics.loading = false;
        state.lastThreeMetrics.error = action.payload;
      })
      // --- current metrics ---
      .addCase(fetchCurrentMetrics.pending, (state) => {
        state.currentMetrics.loading = true;
        state.currentMetrics.error = null;
      })
      .addCase(fetchCurrentMetrics.fulfilled, (state, action) => {
        state.currentMetrics.loading = false;
        state.currentMetrics.summary = action.payload.currentMonthSummary;
        state.currentMetrics.metrics = action.payload.monthlyMetrics;
        state.currentMetrics.highestSpend = action.payload.highestSpendSuppliers;
      })
      .addCase(fetchCurrentMetrics.rejected, (state, action) => {
        state.currentMetrics.loading = false;
        state.currentMetrics.error = action.payload;
      })
      // --- yearly metrics ---
      .addCase(fetchYearlyMetrics.pending, (state) => {
        state.yearlyMetrics.loading = true;
        state.yearlyMetrics.error = null;
      })
      .addCase(fetchYearlyMetrics.fulfilled, (state, action) => {
        state.yearlyMetrics.loading = false;
        state.yearlyMetrics.summary = action.payload.currentYearSummary;
        state.yearlyMetrics.metrics = action.payload.yearlyMetric;
        state.yearlyMetrics.highestSpend = action.payload.highestSpendSuppliers;
      })
      .addCase(fetchYearlyMetrics.rejected, (state, action) => {
        state.yearlyMetrics.loading = false;
        state.yearlyMetrics.error = action.payload;
      });
  },
});

export default metricsSlice.reducer;
